import axios from "axios";

export const getLinesContainer = async () => {
    return await axios.get(`/api/containers/lines/`)
}